// Cloudflare R2 storage client (frontend-only).
// Files are uploaded through a Cloudflare Worker that streams them into an R2
// bucket. The Worker verifies the caller's Firebase ID token (admin only).

const WORKER_URL = (process.env.REACT_APP_R2_WORKER_URL || "https://frienddoors-r2.agdamliuser02.workers.dev").replace(/\/$/, "");
const PUBLIC_URL = (process.env.REACT_APP_R2_PUBLIC_URL || "https://pub-4949f032d77e4e649ab5b947cb242718.r2.dev").replace(/\/$/, "");

export function isStorageConfigured() {
  return !!WORKER_URL;
}

// Resolve a stored value (full URL or bare key) into a displayable URL.
export function fileUrl(idOrUrl) {
  if (!idOrUrl) return "";
  if (/^https?:\/\//i.test(idOrUrl)) return idOrUrl;
  if (PUBLIC_URL) return `${PUBLIC_URL}/${idOrUrl}`;
  if (WORKER_URL) return `${WORKER_URL}/file/${idOrUrl}`;
  return idOrUrl;
}

// Upload a File/Blob to R2 via the Worker. Returns { key, url }.
export async function uploadToR2(file, { idToken, onProgress } = {}) {
  if (!WORKER_URL) {
    const err = new Error("Fayl saxlama qurulmayıb (Cloudflare R2 Worker URL yoxdur).");
    err.response = { status: 500, data: { detail: err.message } };
    throw err;
  }
  const endpoint = `${WORKER_URL}/upload?filename=${encodeURIComponent(file.name || "file")}`;
  return await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", endpoint);
    xhr.setRequestHeader("Content-Type", file.type || "application/octet-stream");
    if (idToken) xhr.setRequestHeader("Authorization", `Bearer ${idToken}`);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && typeof onProgress === "function") {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try { resolve(JSON.parse(xhr.responseText)); }
        catch (_) { reject(mkErr(500, "Serverdən yanlış cavab")); }
      } else {
        let detail = `Yükləmə uğursuz oldu (${xhr.status})`;
        try { detail = JSON.parse(xhr.responseText).error || detail; } catch (_) { /* noop */ }
        reject(mkErr(xhr.status, detail));
      }
    };
    xhr.onerror = () => reject(mkErr(0, "Yükləmə zamanı şəbəkə xətası"));
    xhr.send(file);
  });
}

function mkErr(status, detail) {
  const e = new Error(detail);
  e.response = { status, data: { detail } };
  return e;
}
